import { Box, InfoIcon, Text } from '@wix/design-system';
import { DateUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCredit } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
export const CreditExplanation = () => {
  var _currentProductQuery$;
  const module = useCurrentModule();
  const currentProductQuery = module.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const currentProduct = (_currentProductQuery$ = currentProductQuery.data) == null ? void 0 : _currentProductQuery$.currentProduct;
  const daysLeft = DateUtils.getDaysUntil(currentProduct == null ? void 0 : currentProduct.periodEndDate);
  const {
    bi
  } = module.internals;
  const {
    t
  } = module.internals.useTranslations();
  const credit = useCredit();
  const isLoading = currentProductQuery.isLoading || credit.isLoading;
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    verticalAlign: "middle",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "credit-explanation"
  }, t('Advanced_Second_Upgrade_Credit_Explanation')), /*#__PURE__*/React.createElement(InfoIcon, {
    dataHook: "credit-explanation-info",
    size: "small",
    content: t('Advanced_Plans.second_upgrade.credit_explanation.tooltip', {
      count: daysLeft,
      credit: credit.formattedValue
    }),
    tooltipProps: {
      maxWidth: 300,
      onShow: () => {
        bi.onCreditTooltipHover == null || bi.onCreditTooltipHover({});
      }
    }
  }));
};
//# sourceMappingURL=CheckoutCreditExplanation.js.map